import styled from 'styled-components'

export const Wrapper = styled.div`
	text-align: center;
	justify-content: center;
	display: flex;
	.react-datepicker-wrapper {
		margin: var(--mg-xs) 0px;
		.react-datepicker__input-container input[type='text'] {
			width: 90%;
			margin: var(--mg-xs) 0px;
			height: var(--it-hg-lg);
			border-radius: var(--border-radius-xs);
			border: 1px solid var(--border-color);
			background: transparent;
			color: white;
			color: var(--text-white-color);
			font-size: var(--fs-sm);
			font-weight: var(--fw-sm);
			padding-left: 10px;
			letter-spacing: 0.15px;
			&::placeholder {
				color: var(--placeholder-color);
			}
		}
	}
`
export const Width = styled.div`
	max-width: 1680px;
	width: 97%;
`
